<div class="white-bg no-padding no-margin">
  <mat-card>
    <div style="text-align: center;">
      <span class="title-header">Undercarriage Repair and Replacement Option</span>
    </div>
    <div class="panel" *ngIf="equipmentDetails != null">
      <div class="panel__header">
        <span class="panel__header__title">
          {{ Translate('Equipment Details') }}
        </span>
      </div>
      <div class="panel__content flex flex--align-center">


        <div class="overall-eval-container">
          <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo" (click)="EdiEqImage(equipmentDetails.EquipmentPhoto)" />
          <div *ngIf="equipmentDetails.FamilyId!=203" class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.Eval }}" style="margin-right: 1px;">
            {{equipmentDetails.PercentWorn | number:'1.0-1'}}%
          </div>

          <div *ngIf="equipmentDetails.FamilyId==203 &&  (equipmentDetails.SumWornL==null || equipmentDetails.SumWornR==null) " class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.Eval }}" style="margin-right: 1px;">
            {{equipmentDetails.PercentWorn | number:'1.0-1'}}%
          </div>

          <div *ngIf="equipmentDetails.FamilyId==203" style="display: flex; flex-direction: column;justify-content: space-evenly; margin-left: 0px;">
            <div *ngIf="equipmentDetails.SumWornL!=null" class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.SumWornL | wornPercentageToEval}}"
                 style="font-size: 24px; text-align: start;    margin-right: 0px;  border-radius: 8px 8px 8px 8px">
              L {{equipmentDetails.SumWornL | number:'1.0-1'}}%
            </div>
            <div *ngIf="equipmentDetails.SumWornR!=null" class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.SumWornR | wornPercentageToEval}}"
                 style="font-size: 24px; text-align: start;    margin-right: 0px;     border-radius: 8px 8px 8px 8px">
              R {{equipmentDetails.SumWornR | number:'1.0-1'}}%
            </div>
          </div>

          <div *ngIf="equipmentDetails.FamilyId==203" style="display: flex; flex-direction: column;justify-content: space-evenly; margin-left: 2px;">
            <div *ngIf="equipmentDetails.SumWornL!=null" class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.SumWornL | wornPercentageToEval}}"
                 style="font-size: 24px; text-align: start;    margin-right: 0px;  border-radius: 8px 8px 8px 8px">
              {{equipmentDetails.MonoblockCMUL | number:'1.0-1' }} / {{equipmentDetails.MonoblockResidualL | number:'1.0-1'}}
            </div>
            <div *ngIf="equipmentDetails.SumWornR!=null" class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.SumWornR | wornPercentageToEval}}"
                 style="font-size: 24px; text-align: start;    margin-right: 0px;     border-radius: 8px 8px 8px 8px">
              {{equipmentDetails.MonoblockCMUR | number:'1.0-1' }} / {{equipmentDetails.MonoblockResidualR | number:'1.0-1'}}
            </div>
          </div>


        </div>
        <div class="column-container flex-grow" style="margin-left: 1%;">
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Customer') }}
              </span>
              <span class="text-block__important">
                {{equipmentDetails.CustomerName}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Job Site') }}
              </span>
              <span class="text-block__important">
                {{equipmentDetails.JobsiteName}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Serial Number') }}
              </span>
              <span class="text-block__important">
                <a routerLink="/equipment/{{equipmentId}}">
                  {{equipmentDetails.SerialNumber}}
                </a>

              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Unit Number') }}
              </span>
              <span class="text-block__important">
                <a routerLink="/equipment/{{equipmentId}}">
                  {{equipmentDetails.UnitNumber}}
                </a>

              </span>
            </div>
          </div>
          <div class="column-container__column" *ngIf="equipmentDetails.AdditionalUnitNo!= null ">
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Additional Unit Number') }}
              </span>
              <span class="text-block__important">
                {{equipmentDetails.AdditionalUnitNo}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">

              </span>
              <span class="text-block__important">

              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Last Inspection Date') }}
              </span>
              <span class="text-block__important">
                {{equipmentDetails.LastInspectionDate}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Next Inspection Date') }}
              </span>
              <span class="text-block__important">
                {{ equipmentDetails.NextInspectionDate }}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Meter Reading (SMU/HourMeter)') }}
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Smu}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Life to Date (LTD)') }}
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Ltd}}
              </span>
            </div>
          </div>

          <div class="column-container__column" *ngIf="equipmentDetails.ShowPropelHrsPerc">
               <!--*ngIf="(equipmentDetails.FamilyId==177 || equipmentDetails.FamilyId==203)">-->
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Propel Hrs') }}
              </span>
              <span class="text-block__important">
                {{equipmentDetails.propelHrs!=null? equipmentDetails.propelHrs:'-'}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Propel %') }}
              </span>
              <span class="text-block__important">
                {{equipmentDetails.propelHrs!=null?equipmentDetails.propelPercentage:'-'}}
              </span>
            </div>
          </div>
          <div class="column-container__column" *ngIf="enableDistTravelledTracking">
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Fwd Dist. ') }} ({{userUOD}}) 
              </span>
              <span class="text-block__important">
                {{convertDistanceKmToMi(equipmentDetails.DistanceForward)}}
              </span>
            </div>
            <div class="text-block">
              <div class="dist">
                <div>
                  <span class="text-block__label">
                    {{ Translate('Rev Dist. ') }} ({{userUOD}})
                  </span>
                  <span class="text-block__important">
                    {{convertDistanceKmToMi(equipmentDetails.DistanceReverse)}}
                  </span>
                </div>
                <div class="distpadding">
                  <span class="text-block__label">
                    {{ Translate('Total ') }} ({{userUOD}})
                  </span>
                  <span class="text-block__important">
                    {{convertDistanceKmToMi(equipmentDetails.DistanceForward + equipmentDetails.DistanceReverse)}}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Make') }}
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Make}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Model') }}
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Model}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Family') }}
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Family}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Setup Date') }}
              </span>
              <span class="text-block__important">
                {{equipmentDetails.EquipmentSetupDate}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="equipmentDetails!=null" class="panel ng-star-inserted">
      <div class="headerdivfull">
        <div style="padding-top: 13px;">
          <mat-checkbox class="example-margin" [(ngModel)]="IsReplaceAll"
                        (change)="ChangeReplaceFullUC()"> <span class="headerlabel">Replace Full Undercarriage</span></mat-checkbox>
        </div>
        <div style="padding-left: 20px;">
          <mat-form-field *ngIf="IsReplaceAll==true" style="max-width: 110px;">
            <mat-select placeholder="Select Brand" [(ngModel)]="SelectedBrand" (selectionChange)="UpdateAllComponentBrand()">
              <mat-option *ngFor="let make of Makes" [value]="make.Id">
                {{ make.Title }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="topheaderbar">

        <div class="headerdiv">
          <span class="headerlabel">
            <b>{{'Date of Action' | translate | async}} </b> <span style="color: red;">*</span>
          </span>
          <mat-form-field class="action-input" style="max-width: 118px;">
            <input min="{{equipmentDetails?.EquipmentSetupDate | date:'yyyy-MM-dd'}}" matInput
                   [matDatepicker]="myDatepicker"
                   (ngModelChange)="pickedEventDate($event);ChecklastInspectionDateAndSMU()"
                   max="{{today | date:'yyyy-MM-dd'}}" freadonly (click)="myDatepicker.open()" [(ngModel)]="Actiondate"
                   required autofocus>
            <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #myDatepicker></mat-datepicker>
            <!-- [ngModel]="action.ActionDate"  -->
          </mat-form-field>
        </div>
        <div class="headerdiv">
          <span class="headerlabel">
            <b>{{'SMU/Hourmeter at Action Date ' | translate | async}} </b>
            <span style="color: red;">*</span>
          </span>
          <mat-form-field class="action-input" style="   max-width: 100px;">
            <input matInput type="number" [(ngModel)]="NewSMU" required
                    (change)="ChecklastInspectionDateAndSMU()">
          </mat-form-field>
        </div>
        <ng-container *ngIf="enableDistTravelledTracking">
          <div class="headerdiv">
            <span class="headerlabel">
              <b>{{'Distance Forward' | translate | async}} ({{userUOD}}) </b>
            </span>
            <mat-form-field class="action-input" style="   max-width: 130px;">
              <input matInput type="number" [(ngModel)]="distanceForward">
            </mat-form-field>
          </div>

          <div class="headerdiv">
            <span class="headerlabel">
              <b>{{'Distance Reverse' | translate | async}} ({{userUOD}}) </b>
            </span>
            <mat-form-field class="action-input" style="   max-width: 130px;">
              <input matInput type="number" [(ngModel)]="distanceReverse">
            </mat-form-field>
          </div>
          <div class="headerdiv">
            <span class="headerlabel">
              <b>{{'Total Distance' | translate | async}} ({{userUOD}}) </b>
            </span>
            <span class="totaldistance">{{distanceForward + distanceReverse}}</span>
          </div>
        </ng-container>
        <div *ngIf="equipmentDetails.ShowPropelHrsPerc" class="headerdiv">
          <span class="headerlabel"><b>{{'Propel Hours' | translate | async}}</b></span>
          <mat-form-field class="action-input" style="   max-width: 95px;">
            <input matInput type="number" [(ngModel)]="NewPropel">
          </mat-form-field>
        </div>
        <div class="headerdiv">
          <span class="headerlabel"><b>Select Side</b> <span style="color: red;">*</span></span>
          <mat-form-field class="action-input" style="max-width: 100px;">
            <mat-select [(ngModel)]="selectedSide" (selectionChange)="ChangeSide()" required>
              <mat-option [value]="1">Left</mat-option>
              <mat-option [value]="2">Right</mat-option>
              <mat-option [value]="3">Both</mat-option>
            </mat-select>
          </mat-form-field>

        </div>

        <div class="headerdiv">
          <span class="headerlabel"><b>WO #</b></span>
          <mat-form-field class="action-input" style="min-width: 185px;">
            <input matInput type="text" [(ngModel)]="workOrderNo"
                   (change)="UpdateWOForComponents()" autofocus>
          </mat-form-field>

        </div>

        <div class="headerdiv" style="display: flex; justify-content: space-around;">
          <mat-checkbox class="example-margin" [(ngModel)]="ActiveWorkOrder" style="margin-top: 6px;">
            <span class="headerlabel">Activate WO# against Components</span>
          </mat-checkbox>
        </div>



      </div>

    </div>

    <div *ngIf="ShowWarning==true">
      <span *ngIf="ShowWarning==true" class="headerlabel" style="font-weight: bold;color: red;">{{warning}}</span>
    </div>

    <div class="center" *ngIf="equipmentSystems == null || IsLoading==true">
      <mat-spinner></mat-spinner>
    </div>
    
    <mat-card *ngIf="selectedSide>0 && NewSMU!=null" class="divcomponent">
      <div class="div-header" style="font-size: 20px;color: #1D2F36;font-weight: 100;">
        <span>Currently Installed Details</span>
        <span style="margin-left: -6%;">Action Section</span>
        <span>Repair or Replace Action Details</span>
      </div>
      <div class="panel panel--components" *ngFor="let system of equipmentSystems" style="padding: 1%;">
        <div style="display: flex; gap: 30px;">
          <div style="width: 30%; ">
            <span style="    font-size: 20px;color: #1D2F36;font-weight: 100;">
              {{system.Side}} Side -
              {{system.SystemType}} - {{system.SerialNumber}}
            </span>
          </div>
          <div>
            <mat-form-field class="input-action">
              <mat-select placeholder="Select Action" [(ngModel)]="system.ActionSelectionId" (selectionChange)="ChangeReplacementOptionType(system,system.Side)">
                <mat-option [value]="1">No Action</mat-option>
                <mat-option [value]="2">Replace</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field *ngIf="system.ActionSelectionId==2" class="input-serial">
              <mat-select placeholder="Select Action Type" [(ngModel)]="system.SysReplaceActionId"
                          (selectionChange)="ChangeReplacementOptionForSystem(system,system.Side)" required>
                <mat-option *ngIf="system.SystemType=='Frame'" [value]="3">New Components</mat-option>
                <mat-option *ngIf="system.SystemType=='Frame'" [value]="1">New Frame & Components</mat-option>
                <mat-option *ngIf="system.SystemType=='Frame'" [value]="4">New Frame & Original Components</mat-option>
                <mat-option *ngIf="system.SystemType=='Chain'" [value]="1">New</mat-option>
                <mat-option [value]="2">Inventory</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="(system.SysReplaceActionId==1 || system.SysReplaceActionId==4) && system.ActionSelectionId==2">
            <mat-form-field class="input-serial">
              <input matInput required placeholder="New Serial" [value]="system.NewSerialNo" (focusout)="ChangesSerial(system,$event)">
            </mat-form-field>
          </div>
          <div *ngIf="system.SysReplaceActionId==2  && system.ActionSelectionId==2">
            <mat-form-field *ngIf="system.Side=='Left' && system.SystemType=='Chain' && system.SysReplaceActionId==2  && system.ActionSelectionId==2">
              <mat-select (selectionChange)="selectedSystemReplacement($event,system.Side,system.SystemType,selectedReplacement)"
                          name="'Select Available Replacement'"
                          placeholder="{{Translate('Select Available Replacement')}}">
                <mat-option *ngFor="let replacement of getAvailableReplacements(availableSystemReplacementsL, 'Left', 'Chain')" #selectedReplacement
                            [value]="replacement">
                  {{ replacement.SystemSerialNumber }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="system.Side=='Right'&& system.SystemType=='Chain' && system.SysReplaceActionId==2 && system.ActionSelectionId==2">
              <mat-select (selectionChange)="selectedSystemReplacement($event,system.Side,system.SystemType,selectedReplacement1)"
                          name="'Select Available Replacement'"
                          placeholder="{{Translate('Select Available Replacement')}}">
                <mat-option *ngFor="let replacement of getAvailableReplacements(availableSystemReplacementsR, 'Right', 'Chain')" #selectedReplacement1
                            [value]="replacement">
                  {{ replacement.SystemSerialNumber }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="system.Side=='Left' && system.SystemType=='Frame' && system.SysReplaceActionId==2 && system.ActionSelectionId==2">
              <mat-select (selectionChange)="selectedSystemReplacement($event,system.Side,system.SystemType,selectedReplacement2)"
                          name="'Select Available Replacement'"
                          placeholder="{{Translate('Select Available Replacement')}}">
                <mat-option *ngFor="let replacement of getAvailableReplacements(availableSystemReplacementsLFrame, 'Left', 'Frame')" #selectedReplacement2
                            [value]="replacement">
                  {{ replacement.SystemSerialNumber }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="system.Side=='Right' && system.SystemType=='Frame' && system.SysReplaceActionId==2 && system.ActionSelectionId==2">
              <mat-select (selectionChange)="selectedSystemReplacement($event,system.Side,system.SystemType,selectedReplacement3)"
                          name="'Select Available Replacement'"
                          placeholder="{{Translate('Select Available Replacement')}}">
                <mat-option *ngFor="let replacement of getAvailableReplacements(availableSystemReplacementsRFrame, 'Right', 'Frame')" #selectedReplacement3
                            [value]="replacement">
                  {{ replacement.SystemSerialNumber }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div *ngIf="(system.SysReplaceActionId==1 || system.SysReplaceActionId==4 || system.SysReplaceActionId==2) && system.ActionSelectionId==2" style="display: flex; flex-direction: column;">
            <span class="text-block__label" style="padding: 0px 0px 5px 14px;">{{(system.SystemType=='Chain' ? 'Old Chain Status' : 'Old Frame Status') | translate | async}}</span>
            <mat-radio-group [(ngModel)]="system.RemoveStatusId">
              <mat-radio-button [value]="1">{{translate('Off Machine')}}</mat-radio-button>
              <mat-radio-button [value]="5">{{translate('Scrapped')}}</mat-radio-button>
            </mat-radio-group>
          </div>

          <div *ngIf="(system.SysReplaceActionId == 1 || system.SysReplaceActionId == 4) && system.SystemType=='Frame'">
            <mat-form-field class="input-budget">
              <input matInput placeholder="{{Translate('Budget Life')}}" name="FrameBudgetLife" [(ngModel)]="system.NewBudgetLife">
              <span matSuffix>{{Translate('Hrs')}}</span>
            </mat-form-field>
          </div>
          <div *ngIf="(system.SysReplaceActionId == 1 || system.SysReplaceActionId == 4) && system.SystemType=='Frame'">
            <mat-form-field class="input-budget">
              <input matInput placeholder="{{Translate('Budget Distance')}}" name="FrameBudgetDistance" [(ngModel)]="system.NewBudgetDistance">
              <span matSuffix>{{Translate('Km')}}</span>
            </mat-form-field>
          </div>
          <div *ngIf="(system.SysReplaceActionId == 1 || system.SysReplaceActionId == 4) && system.SystemType=='Frame'">
            <mat-form-field class="input-budget">
              <input matInput placeholder="{{Translate('Frame Cost')}}" name="FrameCost" [(ngModel)]="system.NewFrameCost">
            </mat-form-field>
          </div>
        </div>
        <div class="panel__content no-padding">
          <table class="table table--striped table--full-width">
            <thead>
              <tr>
                <th></th>
                <th>{{'Component' | translate | async}}</th>
                <th style="padding: 0px 0px;">{{'Pos' | translate | async}}</th>
                <th style="padding: 0px 12px;">{{'Brand' | translate | async}}</th>
                <th class="right-align" style="padding: 0px 10px;">{{'CMU' | translate | async}}</th>
                <th class="right-align" style="padding: 0px 10px;" *ngIf="enableDistTravelledTracking">{{'DOC' | translate | async}}</th>
                <th style="padding: 0px 8px;">{{'Worn (%)' | translate | async}}</th>
                <th style="padding: 0px 2px;">{{'Action Selection' | translate | async}}</th>
                <th style="padding: 0px;">{{'Action Type' | translate | async}}</th>
                <th class="actionDetailsHeader">{{'Available Replacement' | translate | async}}</th>
                <th class="actionDetailsHeader">{{'Brand' | translate | async}}</th>
                <th class="actionDetailsHeader"> </th>
                <th class="actionDetailsHeader">{{'Worn %' | translate | async}}</th>
                <th class="actionDetailsHeader" style="padding: 0px;">{{'Budget Life' | translate | async}}</th>
                <th class="actionDetailsHeader">{{'CMU' | translate | async}}</th>
                <th class="actionDetailsHeader" style="padding: 0px;" *ngIf="enableDistTravelledTracking">{{'Budget Distance' | translate | async}}</th>
                <th class="actionDetailsHeader" *ngIf="enableDistTravelledTracking">{{'DOC' | translate | async}}</th>
                <th class="actionDetailsHeader">{{'Cost' | translate | async}}</th>
                <th class="actionDetailsHeader" *ngIf="ActiveWorkOrder==true">{{'WO #' | translate | async}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let component of system.Components" [ngClass]="{'ErrorAction': component.ActionSucess==2}">

                <td class="component-cell">
                  <div class="component-photo-container">
                    <img [src]="component.Photo" alt="Component photo"
                         class="component-photo" />
                  </div>
                </td>

                <td>
                  <div title="{{component.Name}}" class="ComponentNameText">{{component.Name}}</div>
                </td>
                <td>
                  <div>
                    {{showPosition(component.Position, component.CompartTypeId)}}
                  </div>
                </td>
                <td title="{{getTitle(component)}}">{{component.Brand}}</td>

                <td class="right-align">{{component.Cmu}}</td>
                <td class="right-align" *ngIf="enableDistTravelledTracking">{{component.DOC}}</td>
                <td style="padding: 0px; ">
                  <div style="display: flex; flex-direction: row;">
                    <span *ngIf="component.isLatest==true" class="Eval-{{ component.EvalCode}}" >
                      <div *ngIf="component.Reading !== -1" style="width:25px">
                        {{component.PercentWorn?.toFixed(0)}}%
                      </div>
                      <div *ngIf="component.Reading === -1" style="width:25px">{{'-'}}</div>
                    </span>
                    <span *ngIf="component.isLatest==false" class="Eval-{{ component.EvalCode}}"
                          style="border-style: double;border-width: thick;" title="Result are not from latest inspection">
                      <div *ngIf="component.Reading !== -1" style="width:25px">
                        {{component.PercentWorn?.toFixed(0)}}%
                      </div>
                      <div *ngIf="component.Reading === -1" style="width:25px">{{'-'}}</div>
                    </span>

                  </div>

                </td>

                <td>
                  <mat-form-field style="max-width: 100px;">
                    <mat-select placeholder="Select Action" [(ngModel)]="component.ActionSelectionId"
                                (selectionChange)="ChangeActionSelection(component, $event)">
                      <mat-option [value]="1">No Action</mat-option>
                      <mat-option [value]="2">Replace</mat-option>
                      <mat-option [value]="3">Repair</mat-option>
                      <mat-option [value]="4" *ngIf="system.SystemType=='Frame'">Keep Component</mat-option>
                    </mat-select>
                  </mat-form-field>

                </td>
                <td style="padding: 0px;">
                  <mat-form-field *ngIf="(component.CompartTypeId!=230  && component.CompartTypeId!=231) && system.SysReplaceActionId!=2 && component.ActionSelectionId != 1 && component.ActionSelectionId != 4">
                    <mat-select placeholder="Select Action Type" [(ngModel)]="component.SelectedActionTypeId"
                                (selectionChange)="ChangeAvailableAction(component,system)" required>
                      <mat-option *ngFor="let action of component.AvailableActions" [value]="action.ActionTypeId">
                        {{ action.ActionTypeName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field *ngIf="(component.CompartTypeId==230 || component.CompartTypeId==231) && (component.ActionSelectionId==3 || component.ActionSelectionId==2) && system.SysReplaceActionId!=2">
                    <mat-select placeholder="Select Action Type" [(ngModel)]="component.SelectedActionTypeId"
                                (selectionChange)="ChangeAvailableAction(component,system)" required>
                      <mat-option *ngFor="let action of component.AvailableActions" [value]="action.ActionTypeId">
                        {{ action.ActionTypeName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                </td>
                <td class="actionDetailsHeader">

                  <div *ngIf=" (component.SelectedActionTypeId === 10602 || component.SelectedActionTypeId === 17 || component.SelectedActionTypeId === 10702) && system.SysReplaceActionId!=2 && component.ActionSelectionId == 3">
                    <mat-form-field *ngIf="component.allRollers?.length >= 1">
                      <mat-select name="Roller To Swap" [(ngModel)]="component.SwapComponentId" placeholder="{{'Select Swap component' | translate | async}}" disableOptionCentering panelClass="myPanelClass" required>
                        <mat-option *ngFor="let roller of component.allRollers"
                                    (click)="swapRollerEvent(roller,component,system)" [value]="roller.Id">
                          <span *ngIf="selectedSide==3">{{ roller.Side }} </span>{{ roller.Name }} {{ roller.Position }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div style="margin-left: 25px; color: orange;" *ngIf="component.allRollers?.length == 0 || component.allRollers === null || component.allRollers === undefined">
                      {{ 'Note : There are not enough same type of rollers to swap position with on this system' | translate | async }}
                    </div>
                  </div>
                  <div *ngIf="component.ChainSysReplaceAction==2 && system.SysReplaceActionId!=2">
                    <mat-form-field *ngIf="system.Side=='Left'">
                      <mat-select (selectionChange)="selectedSystemReplacement($event,system.Side,null,null)"
                                  [(ngModel)]="newSystemIdL" name="'Select Available Replacement'"
                                  placeholder="{{Translate('Select Available Replacement')}}">
                        <mat-option *ngFor="let replacement of availableSystemReplacementsL"
                                    [value]="replacement.SystemId">
                          {{ replacement.SystemSerialNumber }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field *ngIf="system.Side=='Right'">
                      <mat-select (selectionChange)="selectedSystemReplacement($event,system.Side,null,null)"
                                  [(ngModel)]="newSystemIdR" name="'Select Available Replacement'"
                                  placeholder="{{Translate('Select Available Replacement')}}">
                        <mat-option *ngFor="let replacement of availableSystemReplacementsR"
                                    [value]="replacement.SystemId">
                          {{ replacement.SystemSerialNumber }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div *ngIf="(component.ChainSysReplaceAction!=2  || component.ChainSysReplaceAction==null )&& component.SelectedActionTypeId !== 10602 && component.SelectedActionTypeId !== 17 && component.SelectedActionTypeId !== 10702 && system.SysReplaceActionId!=2 && component.ActionSelectionId == 2">
                    <mat-form-field>
                      <mat-select name="ChainSysReplaceActions" placeholder="Select Replacement" [(ngModel)]="component.ActionComponentId" required>
                        <mat-option *ngFor="let action of component.ActionsReplaceOption" [value]="action.Id">
                          {{ action.Name }}
                        </mat-option>

                      </mat-select>
                    </mat-form-field>
                  </div>

                </td>
                <td style="padding: 0px;" class="actionDetailsHeader">
                  <mat-form-field style="max-width: 110px;" *ngIf="system.SysReplaceActionId!=2 && component.ActionSelectionId == 2">
                    <mat-select placeholder="Select Brand" [(ngModel)]="component.ActionBrandId">
                      <mat-option *ngFor="let make of Makes" [value]="make.Id">
                        {{ make.Title }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
                <td class="actionDetailsHeader">
                  <span *ngIf="!component.ActionComment || component.ActionComment=='' " (click)="OpenActionComment(component)" title="Action Comment"
                        style="cursor: pointer;"> <i class="material-icons">message</i></span>
                  <span *ngIf="component.ActionComment && component.ActionComment!=''" (click)="OpenActionComment(component)" title="Action Comment"
                        style="cursor: pointer;">
                    <i class="material-icons"
                       style="color: cornflowerblue;">message</i>
                  </span>
                  <span *ngIf="component.showCalcuator" (click)="OpenCalculator(component)" style="cursor: pointer;" title="Calculate Worn">
                    <i *ngIf="!allowWornInput(component.SelectedActionTypeId)" class="material-icons">calculate</i>
                    <i *ngIf="allowWornInput(component.SelectedActionTypeId)" style="background-color: red;" class="material-icons">calculate</i>
                  </span>

                  <!--TT-9611 This is not working but we are happy with this. The user can adjust all fields via the edit component. Can you however hide this cog as it only affects the existing component and users have the functionality in ‘Edit Component’ screen
                  <span *ngIf="component.showShoeDetails" (click)="OpenShoeDeatis(component)" style="cursor: pointer;" title="Shoe Infomation Settings">
                    <i class="material-icons">settings</i>
                  </span>-->
                </td>

                <td style="padding: 0px;" class="actionDetailsHeader">
                  <input style="width: 100px;text-align: center;" [value]="component.ActionWorn"
                         (focusout)="ChangesWorn(component,$event,system)" [disabled]="allowWornInput(system.SysReplaceActionId, component.SelectedActionTypeId)">
                </td>
                <td style="padding: 0px" class="actionDetailsHeader">
                  <input style="width: 100px;text-align: center;" [value]="component.ActionBudgetLife"
                         (focusout)="ChangesBudgetLife(component,$event,system)">
                </td>
                <td style="padding: 0px;" class="actionDetailsHeader">
                  <input style="width: 100px;text-align: center;" [value]="component.ActionCMU" [disabled]="allowCMUInput(system.SysReplaceActionId, component.SelectedActionTypeId)"
                         (focusout)="ChangesCMU(component,$event,system)" [ngClass]="{'mandatoryField': ChangeAction(component)}">
                </td>
                <td style="padding: 0px;" class="actionDetailsHeader" *ngIf="enableDistTravelledTracking">
                  <input style="width: 100px;text-align: center;" [value]="component.ActionBudgetDistance"
                         (focusout)="ChangesBudgetDistance(component,$event,system)" [ngClass]="{'mandatoryField': ChangeAction(component)}">
                </td>
                <td style="padding: 0px;" class="actionDetailsHeader" *ngIf="enableDistTravelledTracking">
                  <input style="width: 100px;text-align: center;" [value]="component.ActionDOC"
                         (focusout)="ChangesDOC(component,$event,system)" [ngClass]="{'mandatoryField': ChangeAction(component)}">
                </td>
                <td style="padding: 0px;" class="actionDetailsHeader">
                  <input style="width: 100px;text-align: center;" [value]="component.ActionCost" type="number" step="0.01"
                         (focusout)="ChangesCost(component,$event,system)"
                         [ngClass]="{'mandatoryField': ChangeActionCost(component)}">
                </td>
                <td *ngIf="ActiveWorkOrder==true" style="padding: 0px;" class="actionDetailsHeader">
                  <input style="width: 100px;text-align: center;" [value]="component.ActionWO" (focusout)="ChangeWorkOrder(component,$event)"> 
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div style="text-align: end; padding-bottom: 15px; padding-right: 18px; ">
        <button mat-raised-button color="warn" *ngIf="!ShowDone" [disabled]="disableSave" (click)="ReloadPage()">
          Save/Update
          <i class="material-icons"></i>
        </button>
        <button mat-raised-button color="warn" *ngIf="ShowDone" (click)="GotEqDetails()">
          Done
          <i class="material-icons"></i>
        </button>
      </div>
    </mat-card>
  </mat-card>
</div>
